import React, { useState, useEffect } from 'react';
import { Checkbox, Input, Select, SelectButtons } from '../';
import { useGlobalState } from '../../hooks';

export const InputStatus = ({
  name,
  value,
  assetCategory,
  label,
  title,
  displayNameCode,
  onChange,
  loading,
  placeholder,
  disabled,
  statusName = 'status_id',
  statusValue,
  statusLabel = 'Status',
  statusPlaceholder = 'Select status...',
  statusTitle = 'Select status, or lifecycle stage, of the asset',
  batchEdit,
  batchEditItems,
  validation,
}) => {
  const [settings] = useGlobalState('settings');
  const [statuses] = useGlobalState('statuses');
  const [displayNames] = useGlobalState('displayNames');

  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    const tmp = statuses?.raw
      .filter(x => x.status_asset_category === assetCategory)
      .map(x => ({
        value: x.status_id,
        ...statuses[x.status_id],
      }));

    setStatusOptions(() => tmp);
  }, []);

  const handleChange = event => {
    onChange && onChange(event);
  };

  let element = null;
  const batchEditItemKey = `batch_${statusName}`;
  disabled = disabled || loading || (batchEdit && !batchEditItems[batchEditItemKey]);
  statusPlaceholder = statusValue === 'multiple' ? '< Multiple >' : statusPlaceholder;

  if (batchEdit) {
    if (settings[`SHOW_${assetCategory.toUpperCase()}_STATUSES`]) {
      if (statusOptions.length <= 4) {
        // Return only select buttons if batchedit and options <= 4
        element = (
          <SelectButtons
            name={statusName}
            value={statusValue}
            options={statusOptions}
            label={!batchEdit && statusLabel}
            title={statusTitle}
            loading={loading}
            onChange={handleChange}
            disabled={disabled}
            placeholder={statusPlaceholder}
            validation={validation}
          />
        );
      } else {
        // Return select if batchedit and options > 4
        element = (
          <Select
            name={statusName}
            value={statusValue === 'multiple' ? undefined : statusValue}
            options={statusOptions}
            label={!batchEdit && statusLabel}
            title={statusTitle}
            loading={loading}
            placeholder={statusPlaceholder}
            onChange={handleChange}
            disabled={disabled}
            sortOptions={false}
            validation={validation}
          />
        );
      }
    } else {
    }
  } else {
    if (settings[`SHOW_${assetCategory.toUpperCase()}_STATUSES`]) {
      // Return input with select if not batchedit and statuses is enabled
      element = (
        <Input
          type="text"
          name={name}
          label={label}
          title={title}
          displayNameCode={displayNameCode}
          value={value}
          onChange={handleChange}
          disabled={loading}
          validation={validation}
          withSelect={true}
          selectProps={[
            {
              name: statusName,
              label: statusLabel,
              tooltip: statusTitle,
              options: statusOptions,
              isMulti: false,
              value: statusValue,
              onChange: handleChange,
              loading: loading,
              placeholder: statusPlaceholder,
              batchEdit: batchEdit,
              batchEditItems: batchEditItems,
            },
          ]}
        />
      );
    } else {
      // Return plain input if statuses is not enabled
      element = (
        <Input
          type="text"
          name={name}
          label={label}
          title={title}
          displayNameCode={displayNameCode}
          value={value}
          onChange={handleChange}
          disabled={loading}
          placeholder={placeholder}
          validation={validation}
        />
      );
    }
  }

  return (
    <React.Fragment>
      {element && batchEdit && (
        <label>
          <Checkbox
            checked={batchEditItems[batchEditItemKey]}
            name={batchEditItemKey}
            label={`Edit ${statusLabel}`}
            onChange={e => onChange(e, 'batch')}
            disabled={loading}
          />
        </label>
      )}
      {element}
    </React.Fragment>
  );
};
